var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.127 3.07343L5.859 1.55343C7.19132 0.815524 8.80968 0.815524 10.142 1.55343L12.874 3.07343C14.1778 3.78618 14.9919 5.15054 15 6.63643V10.8184C14.998 11.9628 14.5193 13.0546 13.679 13.8314C12.8679 14.5863 11.8 15.0043 10.692 15.0004H5.308C4.2 15.0043 3.13206 14.5863 2.321 13.8314C1.48068 13.0546 1.002 11.9628 1 10.8184V6.63643C1.00829 5.15033 1.82281 3.78591 3.127 3.07343Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-12",
    d: "M5.66406 15.0005V13.6005C5.66406 12.3117 6.70881 11.267 7.99756 11.267C9.28632 11.267 10.3311 12.3117 10.3311 13.6005V15.0005",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4080e55c893e6251fbb12f4e6bbd39d1.svg";
export { ForwardRef as ReactComponent };